import React, { useEffect, useState } from "react";
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import { disabledStyle } from "../../../Common/ClickDisable";
import { urlValidation } from "../../../../CloudStorage/CommonFunction";
import BXPImages from "./BXPImages";
import { titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const bxpDatatomap = [
  { title: (<>Project title <AsteriskLabel /></>), name: "title", placeholder: "Enter title" },
  {
    title: (<>Upload file (Upload at least 1 file)  <AsteriskLabel /></>),
    name: "files",
    placeholder: "Drag and drop or Browse file",
  },
  { title: (<>Project URL <AsteriskLabel /></>), name: "url", placeholder: "Type URL " },
];

const validationSchema = Yup.object().shape({
  work_sample: Yup.array().of(
    Yup.object().shape({
      title: titlevalidation.test(
        "conditional-validation",
        "Title is required",
        function (value) {
          const { url, files } = this.parent;
          // If all fields are empty, allow skipping
          const allEmpty =
            !value &&
            (!url || url.trim() == "") &&
            (!files || files.length == 0);
          // Skip validation when all empty
          if (allEmpty) return true;
          // Otherwise, title is required
          return !!value && value.trim() !== "";
        }
      ),
      url: Yup.string()
        .test("conditional-url", "Enter a valid URL", function (value) {
          const { title, files } = this.parent;
          const allEmpty =
            (!title || title.trim() == "") &&
            (!value || value.trim() == "") &&
            (!files || files.length == 0);
          // Skip validation when all empty
          if (allEmpty) return true;
          // Otherwise, validate URL
          return urlValidation(value);
        })
        .required("URL is required"),
      files: Yup.array()
        .test("conditional-files", "At least one file is required", function (value) {
          const { title, url } = this.parent;
          const allEmpty =
            (!title || title.trim() == "") &&
            (!url || url.trim() == "") &&
            (!value || value.length == 0);
          // Skip validation when all empty
          if (allEmpty) return true;
          // Otherwise, require at least 1 file
          return Array.isArray(value) && value.length > 0;
        }),
    })
  ),
});

const BXPWorkSamples = ({ updateindex, bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(null);

  const initialValues = {
    work_sample: bxpData?.work_sample || [
      // {
      //   title: "",
      //   url: "",
      //   files: "",
      // },
    ],
  };

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);



  const handleSubmit = async (values, actions) => {
    setLoading(true);
    setbxpData((prevData) => ({
      ...prevData,
      ...values
    }));

    setLoading(false);

    setActiveTab("PricingTerms");
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };


  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              <h1 className="add-work">
                {updateindex != null ? "Edit" : "Add"} work sample (optional)
              </h1>
              <FieldArray name="work_sample">
                {({ push, remove }) => (
                  <>
                    {formik.values.work_sample.map((sample, index) => (
                      <div key={index} className="work-sample">
                        {bxpDatatomap.map((prop, key) => {
                          if (prop.name == "files") {
                            return (
                              <BXPImages
                                topindex={index}
                                values={formik.values?.work_sample[index]?.files}
                                formik={formik}
                                name={`work_sample[${index}].files`}
                              />

                            );
                          }
                          return (
                            <FieldInput
                              key={key}
                              title={prop.title}
                              name={`work_sample[${index}].${prop.name}`}
                              placeholder={prop.placeholder}
                            />
                          );
                        })}
                        {formik.values.work_sample.length >= 1 && (
                          <div className="remove-sample">
                            <button
                              type="button"
                              className="btn"
                              onClick={() => remove(index)}
                            >
                              Remove Sample
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="button-sample">
                      <button
                        type="button"
                        className="btn"
                        onClick={() => push({ title: "", url: "", files: [] })}
                      >
                        Add More Sample
                      </button>
                    </div>
                  </>
                )}
              </FieldArray>
              <div className="button-container">
                <div
                  style={loading ? disabledStyle : {}}
                  type="button"
                  className="prev-button btn w-100"
                  onClick={() => setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <div
                  className="next-button btn w-100"
                  type="submit"
                  onClick={formik.handleSubmit}
                >
                  {loading ? <LoginLoaderButton /> : "Next"}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default BXPWorkSamples;
